import {
  LOGIN_FAILED,
  LOGIN_LOADING,
  LOGIN_SUCCESS,

  MULTI_POLICY_LOGIN,
  MULTI_POLICY_SUCCESS,

  ACTIVATE_REQUIRED,
  VALIDATION_LOADING,
  VALIDATION_SUCCESS,
  VALIDATION_FAILED
} from '../actions/loginActions.js'
import NgrxAuth from '../../auth/Auth'

const Login = (state = {}, action) => {
  switch (action.type) {
    case ACTIVATE_REQUIRED:
      return Object.assign({}, state, {
        pageLoading: false,
        error: null
      })
    case MULTI_POLICY_LOGIN:
      return Object.assign({}, state, {
        userEmail: action.userEmail,
        userPassword: action.userPassword,
        isSessionValidation: action.isSessionValidation
      })
    case MULTI_POLICY_SUCCESS:
      return Object.assign({}, state, {
        userEmail: null,
        userPassword: null,
        isSessionValidation: false
      })
    case LOGIN_LOADING:
      return Object.assign({}, state, {
        pageLoading: true,
        error: null
      })
    case LOGIN_SUCCESS:
      NgrxAuth.accessToken = action.response.access_token
      return Object.assign({}, state, {
        pageLoading: false,
        error: null,
        user: action.response
      })
    case LOGIN_FAILED:
      return Object.assign({}, state, {
        pageLoading: false,
        error: action.error
      })

    case VALIDATION_LOADING:
      return Object.assign({}, state, {
        valLoading: true,
        error: false
      })
    case VALIDATION_SUCCESS:
      NgrxAuth.accessToken = action.response.access_token
      return Object.assign({}, state, {
        valLoading: false,
        user: action.response,
        valerror: false
      })
    case VALIDATION_FAILED:
      return Object.assign({}, state, {
        valLoading: false,
        valerror: true
      })
    default:
      return state
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/redux/reducers/loginReducer.js